import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import Dialog from './dialogs/Dialog';
import ExtendedDropDownList from './forms/DropDownList';
import withStorage from './utils/withStorage';
import eventEmitter from './utils/eventEmitter';
import { getClientVersion } from './utils/helper';
import ChangePassword from './ChangePassword';
import MFa from './mfa/2FaDialog';
import { ActiveConnectionsDialog } from './navigation/ActiveConnections';
import Button from '../coraWebComponents/buttons/Button';
import withMeta from './utils/withMeta';

export const TABS_TYPE = [
  { name: 'štandardný', id: 0, icon: "columns", class: "view-standard" },
  { name: 'zoznam a detail', id: 1, icon: "rows", class: "view-rows" },
  { name: 'detail a zoznam', id: 2, icon: "layout-stacked", class: "view-rows" },
  { name: 'vedľa seba', id: 3, class: "view-side-by-side" }
];

export const PAGE = [
  { skip: 0, take: 5 },
  { skip: 0, take: 10 },
  { skip: 0, take: 25 },
  { skip: 0, take: 50 },
  { skip: 0, take: 100 },
];
const THEME = [
  { name: "default" },
];
export const FILTERABLE = [
  { name: "nie", filterable: true },
  { name: "áno", filterable: false },
];

export const GRIDSIZE = [
  { name: "Malá", class: "grid-small" },
  { name: "Stredná", class: "grid-medium" },
  { name: "Veľká", class: "grid-large" },
];

export const DETAILSIZE = [
  { name: "Normálny", class: "detail-large" },
  { name: "Kompaktný", class: "detail-small" },
];

/**
 * Settings component
 * @module
 * @param {func} handleConfirmChangePassword - Handle confirm change password function
 * @param {bool} isOpenSettings - Is settings dialog open? 
 * @param {func} handleCloseSettings - Handle close settings function
 * @param {func} handleChange - Handle change function
 * @param {object} theme - Current theme
 * @param {array} themes - Themes
 * @param {object} filterable - Filterable
 * @param {object} applicationSettings - Application settings
 * @param {object} page - Number of entries on one page
 * @param {object} tabsType - Default tab type
 * @param {element} children - Children element
 * @param {func} updateMenu - Function update menu
 * @param {object} gridSize - Height of row in grid
 * @param {object} detailSize - Height of row in detail
 */
function Settings(props) {
  const [isOpenChangePassword, setIsOpenChangePassword] = useState(false);
  const [isOpen2Fa, setIsOpen2Fa] = useState(false);
  const [tabsType, setTabsType] = useState(TABS_TYPE);
  const [isOpenActiveConnections, setIsOpenActiveConnections] = useState(false);

  const handleConfirmSettings = async () => {
    props.storage.setTabsType(props.tabsType);
    props.storage.setPage(props.page);
    props.storage.setFilterable(props.filterable.filterable);
    props.storage.setTheme(props.theme);
    props.storage.setApplicationSettings(props.applicationSettings);
    props.storage.setGridsize(props.gridSize);
    props.storage.setDetailsize(props.detailSize);
    document.body.className = `theme-${props.theme.name}`;
    eventEmitter.changeTabsType(props.tabsType);
    eventEmitter.changePage(props.page);
    eventEmitter.changeFilterable(props.filterable);
    eventEmitter.changeGridsize(props.gridSize);
    eventEmitter.changeDetailsize(props.detailSize);
    props.handleCloseSettings();
    props.homePage && await props.meta.updateHomePage(props.homePage?.MenuID);
  }

  const openChangePasswordDialog = () => {
    setIsOpenChangePassword(true);
  }

  const handleCloseChangePassword = () => {
    setIsOpenChangePassword(false);
  }

  useEffect(() => {
    if (props.allowedTabsTypes && Array.isArray(props.allowedTabsTypes)) {
      if (props.allowedTabsTypes.length === 0) {
        setTabsType(null);
      } else {
        const allowed = TABS_TYPE.filter(x => props.allowedTabsTypes.includes(x.id));
        setTabsType(allowed);
      }
    }

  }, [props.allowedTabsTypes]);

  const themeData = (props.themes || THEME).map(t => ({name: t.name, title: t.title || t.name}))
  let themeValue = props.theme
  themeValue.title = themeValue.title || themeData.find(x => x.name === themeValue.name)?.title
  return (
    <>
      <Dialog
        isOpen={props.isOpenSettings}
        onClose={props.handleCloseSettings}
        onConfirm={handleConfirmSettings}
        title="Nastavenia"
        width={1080}
      >
        <div className="k-content k-window-content k-dialog-content settings">
          <div className="k-form-inline">
            <div className="k-form-field">
              <span className="title">Farebná téma</span>
              <ExtendedDropDownList
                name="theme"
                data={themeData}
                textField="title"
                onChange={props.handleChange}
                value={themeValue}
              />
            </div>
            <div className="k-form-field">
              <span className="title">Počet záznamov na strane</span>
              <ExtendedDropDownList
                name={"page"}
                data={PAGE}
                textField="take"
                onChange={props.handleChange}
                value={props.page}
              />
            </div>
            {tabsType && <div className="k-form-field">
              <span className="title">Predvolené zobrazenie</span>
              <ExtendedDropDownList
                name={"tabsType"}
                data={tabsType}
                textField="name"
                onChange={props.handleChange}
                value={props.tabsType}
              />
            </div>}
            <div className="k-form-field">
              <span className="title">Kompaktný mód</span>
              <ExtendedDropDownList
                name={"filterable"}
                data={FILTERABLE}
                textField="name"
                onChange={props.handleChange}
                value={props.filterable}
              />
            </div>
            <div className="k-form-field">
              <span className="title">Výška riadku v gride</span>
              <ExtendedDropDownList
                name={"gridSize"}
                data={GRIDSIZE}
                textField="name"
                onChange={props.handleChange}
                value={props.gridSize}
              />
            </div>
            <div className="k-form-field">
              <span className="title">Zobrazenie detailu</span>
              <ExtendedDropDownList
                name={"detailSize"}
                data={DETAILSIZE}
                textField="name"
                onChange={props.handleChange}
                value={props.detailSize}
              />
            </div>
            {props.pageList &&
              <div className="k-form-field">
                <span className="title">Štartovací formulár</span>
                <ExtendedDropDownList
                  name={"homePage"}
                  data={props.pageList.filter(el => el.PathText)}
                  textField="PathText"
                  onChange={props.handleChange}
                  value={props.homePage}
                  defaultItem={{ PathText: " - ", MenuID: -1 }}
                  popupSettings={{ width: '600px' }}
                />
              </div>
            }
            {props.children}
            {props.user?.AuthentificationType === 1 &&
              <div className="k-form-field">
                <span className="title">Zmena hesla</span>
                <span className="k-widget">
                  <Button
                    label="Zmeniť heslo"
                    onClick={openChangePasswordDialog}
                  />
                </span>
              </div>
            }
            <div className="k-form-field">
              <span className="title">Dvojfaktorová autentifikácia</span>
              <span className="k-widget">
                <Button
                  label="Zmeniť nastavenie"
                  onClick={() => { setIsOpen2Fa(true); }}
                />
              </span>
            </div>

            {String(window?.config?.enableNotifications)?.trim()?.toLowerCase() === "true" &&
              <div className="k-form-field">
                <span className="title">Moje aktívne prihlásenia</span>
                <span className="k-widget">
                  <Button
                    label="Zobraziť"
                    onClick={() => { setIsOpenActiveConnections(true); }}
                  />
                </span>
              </div>
            }

            <div style={{ float: 'right', paddingRight: 10 }}>
              {`Verzia: ${getClientVersion()}`}
            </div>

          </div>
        </div>
      </Dialog>
      <ChangePassword
        isOpenChangePassword={isOpenChangePassword}
        handleConfirmChangePassword={props.handleConfirmChangePassword}
        handleClose={handleCloseChangePassword}
      />
      {isOpen2Fa &&
        <MFa
          isOpen={isOpen2Fa}
          handleConfirm={() => { }}
          handleClose={() => { setIsOpen2Fa(false); }}
        />
      }
      {isOpenActiveConnections &&
        <ActiveConnectionsDialog
          isOpen={isOpenActiveConnections}
          onClose={() => setIsOpenActiveConnections(false)}
        />
      }
    </>
  );
}

Settings.propTypes = {
  handleConfirmChangePassword: PropTypes.func,
  isOpenSettings: PropTypes.bool.isRequired,
  handleCloseSettings: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  theme: PropTypes.object.isRequired,
  themes: PropTypes.array.isRequired,
  filterable: PropTypes.object,
  applicationSettings: PropTypes.object,
  page: PropTypes.object,
  tabsType: PropTypes.object,
  children: PropTypes.element,
  pageList: PropTypes.array,
  homePage: PropTypes.object,
  updateMenu: PropTypes.func,
  gridSize: PropTypes.object,
  detailSize: PropTypes.object,
  allowedTabsTypes: PropTypes.array,
}

export default withMeta(withStorage(Settings));